import * as React from "react";
import { LazyImage } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
const Measurement = ({ image, label, measurement, isListItem }) => {
  const { getLabel } = useIntl();
  const metric = getLabel("products.measurements.metric");
  const detailLabel = `${measurement} ${metric}`;
  const ContainerElement = isListItem ? "li" : "section";
  return /* @__PURE__ */ React.createElement(ContainerElement, { className: "product-detail-frame-measurements__item" }, /* @__PURE__ */ React.createElement(Text, { spacings: ["mb-5"], variant: "caption-head" }, getLabel(label)), /* @__PURE__ */ React.createElement("div", { className: "product-detail-frame-measurements__image", "aria-hidden": "true" }, /* @__PURE__ */ React.createElement(LazyImage, { src: image.url, alt: "", width: image.width, height: image.height })), /* @__PURE__ */ React.createElement(Text, { variant: "caption-head", className: "product-detail-frame-measurements__details" }, detailLabel));
};
export {
  Measurement
};
//# sourceMappingURL=Measurement.js.map
